import { chakra, InputGroup, Box } from '@stockx/ui';

export const SearchInputWrapper = chakra(InputGroup, {
  baseStyle: {
    /* clears the ‘X’ from Chrome */
    '[type="search"]::-webkit-search-cancel-button, [type="search"]::-webkit-search-decoration':
      {
        WebkitAppearance: 'none',
        appearance: 'none',
      },
  },
});

export const CustomPlaceholder = chakra(Box, {
  baseStyle: {
    height: '21px',
    width: 'calc(100% - 3rem)',
    overflow: 'hidden',
    position: 'absolute',
    fontSize: 'sm',
    marginY: 3,
    marginX: 12,
    color: 'neutral.500',
    whiteSpace: 'nowrap',
    pointerEvents: 'none',
  },
});

export const getScrollUpKeyFrames = (): { [x: string]: object } => ({
  from: {
    transform: 'translateY(5%)', // empty
  },
  '5%': {
    transform: 'translateY(0%)', // 1
  },
  '15%': {
    transform: 'translateY(-10%)', // 2
  },
  '25%': {
    transform: 'translateY(-20%)', // 3
  },
  '35%': {
    transform: 'translateY(-30%)', // 4
  },
  '45%': {
    transform: 'translateY(-40%)', // 5
  },
  '55%': {
    transform: 'translateY(-50%)', // 6
  },
  '65%': {
    transform: 'translateY(-60%)', // 7
  },
  '75%': {
    transform: 'translateY(-70%)', // 8
  },
  '85%': {
    transform: 'translateY(-80%)', // 9
  },
  '95%': {
    transform: 'translateY(-90%)', // 10
  },
  to: {
    transform: 'translateY(-95%)', // empty
  },
});

export const SuggestionList = chakra('ul', {
  baseStyle: {
    '@keyframes scrollUp': getScrollUpKeyFrames(),
    transform: 'translateY(10%)',
    animation: `scrollUp 18s 0s infinite forwards reverse`,
    animationDelay: '3s',
    marginLeft: 1,
    marginTop: '-1.5px',
  },
  label: 'SuggestionList',
});

export const SuggestionListItem = chakra('li', {
  baseStyle: {
    overflow: 'hidden',
    color: 'neutral.500',
    lineHeight: '21px',
  },
  label: 'SuggestionListItem',
});
